import React, { useState, useEffect } from "react";
import './set-password.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Carousel from '../../reusable-components/carousel/Carousel';
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Footer from '../../reusable-components/footer/footer'; 

function SetNewPassword(props) {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");

    useEffect(() => {
        // console.log("Mounting...");
      });

      const sendChangePasswordRequest = () => {
        let item = { 
                    Password: password,
                    ConfirmPassword: confirmPassword
                };    
        console.log("this is item in change password: ", item);

    }


    return (
    <>
        <div className="first-verify__loginContainer">
            <div className='first-verify__leftContainer'>
                <div className='first-verify__logo'></div>
                <div className='first-verify__loginSubContainer'>
                    <div className="first-verify__logoContainer"></div>
                   <span className='first-verify__loginHeading'>{props.content.setPassword.setNewPassword}</span>
                   <span className='first-verify__loginSubheading'>
                    {props.content.setPassword.passwordBanner}
                    </span>
                    <div className='first-verify__logindetails'>
                        <span className='password-label'>{props.content.setPassword.password}</span>
                        <TextField id="outlined-basic" type={"password"} onChange={e => setPassword(e.target.value)} inputProps={{ className: "login-password" }} label={props.content.setPassword.password} variant="outlined" />
                        <span className='password-label'>{props.content.setPassword.updatePassword}</span>
                        <TextField id="outlined-basic" type={"password"} onChange={e => setConfirmPassword(e.target.value)} inputProps={{ className: "login-password" }} label={props.content.setPassword.updatePassword} variant="outlined" />
                    </div>
                    <div className='first-verify__logindetails padding-top-0 text-align-center'>
                        <Button variant="contained" className="login-button" onClick={sendChangePasswordRequest} >{props.content.setPassword.resetPassword}</Button>
                        <Button variant="outlined" className="login-button-backtologin" onClick={() => navigate("/")}><ArrowBackIcon />{props.content.setPassword.backToLogin}</Button>
                    </div>
                </div>
                <Footer />
            </div>
            <div className='first-verify__rightContainer'>
                <div className='first-verify__rightSubContainer'>
                    <div className='first-verify__carousel-container'>
                        <Carousel />
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default SetNewPassword;

